import { Theme, css } from '@emotion/react';

export const buttonGroup = ({ spacing }: Theme) => css`
  display: flex;
  column-gap: ${spacing(1)}px;
`;

export const collapsedChild = ({ spacing }: Theme) => css`
  margin: ${spacing(1.5)}px 0;
`;
